import React from "react"
import { Grid } from "semantic-ui-react"
import CreateHouseholdButton from "./CreateHouseholdButton"

class SearchBar extends React.Component {
  constructor(props) {
    super()
    this.state = { searchValue: "" }
  }
  onHouseholdSearch = searchValue => {
    this.setState({ searchValue })
    this.props.onSearch(searchValue)
  }
  render() {
    const { createHousehold, setCurrentHousehold, currentUser } = this.props
    return (
      <Grid.Row>
        <Grid.Column textAlign="left" width={8}>
          {this.props.showSearch ? (
            <input
              style={{ padding: "0.4em" }}
              placeholder="Search households..."
              onChange={event => this.onHouseholdSearch(event.target.value)}
              value={this.state.searchValue}
            />
          ) : null}
        </Grid.Column>
        <Grid.Column textAlign="right" width={7}>
          {createHousehold && (
            <CreateHouseholdButton
              createHousehold={createHousehold}
              setCurrentHousehold={setCurrentHousehold}
              currentUser={currentUser}
            />
          )}
        </Grid.Column>
      </Grid.Row>
    )
  }
}
export default SearchBar
